/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CurrencyCode {
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
  EUR = "EUR",
  GBP = "GBP",
  HKD = "HKD",
  SGD = "SGD",
  USD = "USD",
}

export const CurrencyCodeDisplay: Record<CurrencyCode, string> = {
  [CurrencyCode.AUD]: "A$",
  [CurrencyCode.CAD]: "CAN$",
  [CurrencyCode.CHF]: "CHF",
  [CurrencyCode.EUR]: "€",
  [CurrencyCode.GBP]: "£",
  [CurrencyCode.HKD]: "HK$",
  [CurrencyCode.SGD]: "S$",
  [CurrencyCode.USD]: "$",
};
